import {
    NOTIFICATIONS_SET_DATA,
    NOTIFICATIONS_RESET_DATA,
    NOTIFICATIONS_RESET_PAGINATION,
    NOTIFICATIONS_SET_PAGINATION,
    NOTIFICATIONS_SET_UNREAD_COUNT,
    NOTIFICATIONS_SET_ISLOADING,
    NOTIFICATIONS_SET_FILTERS,
} from './constants';
import { getNotifications, markNotifications, getNotificationsPolling } from 'src/api/shipmentExecution';
import { getLastSortedColumnValue, getLastItemId } from 'src/utils/pagination';
import { batch } from 'react-redux';

let pollingAgent: ReturnType<typeof setTimeout> | null = null;

export const pollApi = () => async (dispatch) => {
    const response = await getNotificationsPolling();
    if (response.isSuccess) {
        dispatch({
            type: NOTIFICATIONS_SET_UNREAD_COUNT,
            data: response.data.unReadCount,
        });
    }
    dispatch(stopPolling());
    dispatch(startPoller());
};

export const startPoller = () => (dispatch) => {
    const pollingFrequncy = 180000;
    if (!pollingAgent) {
        pollingAgent = setTimeout(() => dispatch(pollApi()), pollingFrequncy);
    }
};

export const stopPolling = () => () => {
    if (pollingAgent) {
        clearTimeout(pollingAgent);
        pollingAgent = null;
    }
};
export const fetchNotifications = ({source, queryString}: { source?: string, queryString?: string } = {}) => async (dispatch, getState) => {
    const pagination = getState().notificationsReducer.pagination;
    const sourceObjectType = source || getState().notificationsReducer.sourceObjectType;
    dispatch({
        type: NOTIFICATIONS_SET_ISLOADING,
        data: true,
    });
    const response = await getNotifications({
        sourceObjectType,
        queryString,
        currentPageNumber: pagination.currentPageNumber,
        nextOrPrev: pagination.nextOrPrev,
        descendingOrder: pagination.descendingOrder,
        resultPerPage: pagination.resultPerPage,
        lastSortedColumnValue: getLastSortedColumnValue(pagination),
        lastRowId: getLastItemId(pagination),
    });
    if (response.isSuccess) {
        dispatch({
            type: NOTIFICATIONS_SET_DATA,
            data: response.data.data
        });
        dispatch({
            type: NOTIFICATIONS_SET_PAGINATION,
            data: {
                currentPageNumber: response.data.currentPageNumber,
                isNextPresent: response.data.isNextPresent,
                lastItemIdNext: response.data.lastItemIdNext,
                lastItemIdPrev: response.data.lastItemIdPrev,
                lastSortedColumnValueNext: response.data.lastSortedColumnValueNext,
                lastSortedColumnValuePrev: response.data.lastSortedColumnValuePrev,
            }
        });
        dispatch({
            type: NOTIFICATIONS_SET_UNREAD_COUNT,
            data: response.data.unReadCount,
        });
    }
    dispatch({
        type: NOTIFICATIONS_SET_ISLOADING,
        data: false,
    });
};
export const resetPagination = () => (dispatch) => {
    dispatch({
        type: NOTIFICATIONS_RESET_PAGINATION,
    });
};
export const resetNotifications = () => (dispatch) => {
    dispatch({
        type: NOTIFICATIONS_RESET_DATA
    });
};
export const handleNextClick = () => (dispatch, getState) => {
    dispatch({
        type: NOTIFICATIONS_SET_PAGINATION,
        data: {
            nextOrPrev: 'next',
        }
    });
    dispatch(fetchNotifications());
};
export const handlePrevClick = () => (dispatch, getState) => {
    dispatch({
        type: NOTIFICATIONS_SET_PAGINATION,
        data: {
            nextOrPrev: 'prev',
        }
    });
    dispatch(fetchNotifications());
};
export const handleFirstClick = () => (dispatch, getState) => {
    dispatch({
        type: NOTIFICATIONS_SET_PAGINATION,
        data: {
            lastSortedColumnValue: undefined,
            currentPageNumber: 1,
            nextOrPrev: 'first',
        }
    });
    dispatch(fetchNotifications());    
};

export const handleTabAndFilterChange = (params: { source?: string , queryString?: string }) => (dispatch) => {
    batch(() => {
        dispatch({
            type: NOTIFICATIONS_SET_FILTERS,
            data: params,
        });
        dispatch(fetchNotifications({ ...params }));
    });
};
